import type { FC, ReactNode } from 'react'
import classNames from 'classnames'

type ToolbarButtonProps = {
  onClick?: () => void
  children: ReactNode
  className?: string
  title?: string
  ariaLabel?: string
  id?: string
  disabled?: boolean
}

const ToolbarButton: FC<ToolbarButtonProps> = ({
  onClick,
  children,
  className,
  title,
  ariaLabel,
  id,
  disabled,
}) => {
  return (
    <button
      onClick={onClick}
      title={title}
      aria-label={ariaLabel || title}
      id={id}
      disabled={disabled}
      className={classNames(
        'flex items-center justify-center rounded-full transition-all duration-200',
        'text-slate-600 dark:text-slate-300',
        'hover:bg-slate-200/50 dark:hover:bg-slate-700/50',
        'active:scale-95',
        'w-9 h-9 md:w-10 md:h-10 lg:w-11 lg:h-11', // Fixed container size
        disabled ? 'opacity-25 cursor-not-allowed' : 'cursor-pointer',
        className
      )}
    >
      <div className="text-lg md:text-xl lg:text-2xl flex items-center justify-center">
        {children}
      </div>
    </button>
  )
}

export default ToolbarButton
